import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { GlobalContextProvider } from "./context/GlobalContext";
import App from "./App";
import theme from "./context/ThemeContext";
import { ThemeProvider } from "@mui/material/styles";
import { msalConfig } from "./config/authConfig";
import setupAxiosInterceptor from "./utils/axiosInterceptor";

export const msalInstance = new PublicClientApplication(msalConfig);

// Configurar el interceptor de axios después de inicializar MSAL
msalInstance.initialize().then(() => {
  setupAxiosInterceptor();
});

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={theme}>
        <GlobalContextProvider>
          <App />
        </GlobalContextProvider>
      </ThemeProvider>
    </MsalProvider>
  </StrictMode>
);
